module.exports = __webpack_public_path__ + "static/img/检查报告@3x.adeadb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/检查报告@3x.png
// module id = 783
// module chunks = 382